module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scaling-squares-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.squaresStyles), function(ss, index) {
    return _c('div', {
      key: index,
      staticClass: "square",
      class: ("square-" + (index + 1)),
      style: (ss)
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42f3dc46","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/ScalingSquaresSpinner.vue
// module id = 268
// module chunks = 1